import { Alert, Box, Button, Grid, Typography } from "@mui/material";

import ExecutiveKpiCard from "./ExecutiveKpiCard";

const ExecutiveKpiGrid = ({
  kpis = [],
  currencyUnit,
  loading,
  error,
  onRetry,
}) => {
  if (error && !loading && kpis.length === 0) {
    return (
      <Alert
        severity="error"
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              تلاش مجدد
            </Button>
          ) : null
        }
        sx={{ mb: 2 }}
      >
        {error}
      </Alert>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
        شاخص‌های کلیدی مدیریتی
      </Typography>
      <Grid container spacing={1.5}>
        {(loading ? Array.from({ length: 10 }) : kpis).map((kpi, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={kpi?.code || kpi?.Code || index}>
            <ExecutiveKpiCard
              kpi={kpi}
              currencyUnit={currencyUnit}
              loading={loading}
              error={!loading && error && !kpi ? error : null}
              onRetry={onRetry}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ExecutiveKpiGrid;
